module.exports = __webpack_public_path__ + "img/home2.b1112fc8.jpg";